import React, { ReactNode } from 'react'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

import { Container, ContainerProps } from './styles'

type Props = ContainerProps & {
  children: ReactNode
}

function SectionWrapper({ children, ...rest }: Props) {
  return (
    <Container px={LANDING_INLINE_PADDINGS} {...rest}>
      {children}
    </Container>
  )
}

export default SectionWrapper
